import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Customer } from "./Customer";
/**
 * Customer settings model
 */

export class CustomerSettings extends BaseModel {
  constructor(...args) {
    super(...args);

    this.primary = () => {
      return 'userId';
    };

    this.getParams = () => this.model.params;

    this.getPoints = () => this.model.params?.points ?? 0;

    this.getEmail = () => this.model.email;

    this.getPhone = () => this.model.phone;

    this.getCityId = () => this.model.cityId;

    this.getImage = () => this.model.image;

    this.getAbsoluteImage = () => this.model.absoluteImage;

    this.getUserId = () => this.model.userId;

    this.isEmailVerified = () => Boolean(this.model.isEmailVerified);

    this.isPhoneVerified = () => Boolean(this.model.isPhoneVerified);

    this.getParam = (param, defaultValue = null) => {
      const params = this.getParams();
      return params && params[param] || defaultValue;
    };

    this.getCustomer = customer => this.getRelation('customer', Customer, customer);

    this.getAttributes = () => {
      const {
        email,
        phone,
        userId
      } = this.model;
      return {
        email,
        phone,
        userId
      };
    };
  }

  /**
   * Create customer settings
   *
   * @param {object} object
   *
   * @return {CustomerSettings}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * @inheritDoc
   */


  primaryKey() {
    return this.model.userId;
  }
  /**
   * @inheritDoc
   */


}